// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canDeleteAssets } from "./check";

export function useCanDeleteAssets(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canDeleteAssets(withinScope);
  return canDoAction;
}
